export function checkRectangleIntersection(rectangle1, rectangle2) {
  const [
    // the coordinates of the top-left corner of the rectangle
    x1,
    y1,
    // the coordinates of the bottom-right corner of the rectangle
    x2,
    y2,
  ] = rectangle1;
  const [
    // the coordinates of the top-left corner of the rectangle
    x3,
    y3,
    // the coordinates of the bottom-right corner of the rectangle
    x4,
    y4,
  ] = rectangle2;

  if (x1 < x4 && x2 > x3 && y1 < y4 && y2 > y3) {
    return true;
  } else {
    return false;
  }
}
